import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { provideDefaultConfigFactory } from '@spartacus/core';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const QUALTRICS_FEATURE = 'qualtrics';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// TODO: Inline this factory when we start releasing Ivy compiled libraries
function defaultQualtricsComponentsConfig() {
  const config = {
    featureModules: {
      [QUALTRICS_FEATURE]: {
        cmsComponents: ['QualtricsComponent']
      }
    }
  };
  return config;
}
let QualtricsRootModule = /*#__PURE__*/(() => {
  class QualtricsRootModule {
    static {
      this.ɵfac = function QualtricsRootModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || QualtricsRootModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: QualtricsRootModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfigFactory(defaultQualtricsComponentsConfig)]
      });
    }
  }
  return QualtricsRootModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { QUALTRICS_FEATURE, QualtricsRootModule, defaultQualtricsComponentsConfig };
